<!-- 产品详情 -->
<template>
  <div class="detail">
    <div class="detial-header">
      <img
        class="header-img"
        :src="detail.detailImg"
        alt
      />
      <div class="header-div">
        <p class="header-p1">{{detail.classification}}</p>
        <p class="header-p">{{detail.model}}</p>
        <p class="header-p">{{detail.specifications}}</p>
      </div>
    </div>
    <div class="features">
      <span>功能特性</span>
      <p class="features-p">{{detail.features}}</p>
    </div>
    <div class="features">
      <span>特色和优势</span>
      <p class="features-p">{{detail.advantage}}</p>
    </div>
    <div class="features">
      <span>技术参数</span>
      <p class="parameter-p">
        <img
          class="parameter-img"
          :src="detail.parameterImg"
          alt
        />
      </p>
    </div>
    <div class="features">
      <span>应用场景</span>
      <p class="features-p">{{detail.scenario}}</p>
    </div>
    <div class="features">
      <span>订货型号</span>

      <li>{{detail.model}}</li>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: {
        indexImg: require("../../../assets/product/Module/snap/CostPerformance/MHC6A-FD-16CV500+GC2053.png"), //产品列表图片
        detailImg: require("../../../assets/product/Module/snap/CostPerformance/MHC6A-FD-CV500-GC2053.png"), //详情图片
        parameterImg: require("../../../assets/product/Module/snap/CostPerformance/MHC6A-FD.png"), //参数图片
        model: "MHC6A-FD", //型号
        classification: "超高性价比", //分类
        specifications: "3516CV500 + GC205338单板", //规格
        scenario: "",
        // 功能特性
        features:
          "200万 1/2.8超宽动态CMOS SENSOR，512M DDR, 256M NAND FLASH, H.264/H265双码流，200万@25帧，RJ45、DC 12V、USB, G711/AAC音频输入输出，可选双光及声光报警，电动变焦（可扩展），TF卡（可扩展），RS485（可扩展），IO报警输入（可扩展输出）。支持RTSP/RTMP/ONVIF/GB28181等标准协议，支持无插件跨平台浏览器访问。支持NETSDK二次开发，支持平台对接接入和设备侧二次开发，支持硬件开放和定制。", //特性
        //优势
        advantage:
          "1：单帧最大32人同时检测抓拍，支持人脸、人形同时检测和绑定。2：支持性别、年龄、带口罩、带帽子等人脸和人形属性分析（增强版本）。3：支持人脸追踪、优选、去重，角度/清晰度过滤。4：支持多种抓拍模式，支持大小图同传，支持HTTP/FTP图片上传。", //优势
      },
    };
  },

  components: {},
  created() {},
  mounted() {
    // 滚动条置顶
    window.scrollTo(0, 0);
    let param = JSON.parse(this.$route.query.detail);
    let arrName = param.arrName,
      index = param.index;

    this.detail = this.$store.state[arrName][index];
  },

  methods: {},
};
</script>
<style scoped>
p {
  padding: 0;
  margin: 0;
}
.detail {
  margin-bottom: 5%;
}
.detial-header {
  display: flex;

  align-items: center;
  height: 20%;
  padding: 0 15% 0 25%;
  background: #f8f8f8;
}
.header-img {
  margin: 2% 2% 2% 0;
}
.header-div {
  margin-left: 10%;
}
.header-p1 {
  font-size: 14px;
  font-weight: 600;
  margin: 4px;
}
.header-p {
  font-size: 14px;

  margin: 4px;
}
.features {
  margin: 2% 0 0 25%;
}
.features span {
  display: inline-block;
  padding-bottom: 8px;
  border-bottom: 2px solid #27bdff;
  font-size: 16px;
  margin-bottom: 1%;
}
.features p {
  font-size: 14px;
  color: #333333;
}
.features-p {
  width: 70%;
}

.parameter-img {
  width: 70%;
  height: 80%;
}
</style>